module.exports = __webpack_public_path__ + "static/media/plateo.5870a876.jpg";